module.exports = __webpack_public_path__ + "img/shop-and-service-filter.688efc83.png";